<template>
  <section class="wp_Specifications">
    <div class="row mx-auto pr-0 mr-0">
      <div class="col-12">
        <h5 id="pdt-sepecification"
												data-test="productSpecificationSectionHeading">
          Specifications
        </h5>
        <table
          class="table spec-table"
          style="width: 99%;"
          v-if="product.product_specification"
        >
          <tbody
            v-for="(spec,index) in product.product_specification"
            :key="index"
          >
            <tr data-test="productSpecificationSectionHeading"
																id="productSpecificationSectionHeading">
              <th :id="'pdt-specification-property-'+index"
																		data-test="productSpecificationSectionPropertyName">
                {{spec.property_name}}
              </th>
              <td :id="'pdt-specification-value-'+index"
																		data-test="productSpecificationSectionPropertyValue">
                {{spec.value}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
export default {
	props: {
		product: {}
	}
}
</script>
